import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavBarService {

  private changeTitleBarSubject = new Subject<string>();


  constructor() { }

  public getTitleBarValue(): Observable<string> {
    return this.changeTitleBarSubject.asObservable();
  }

  public setTitleBarValue(value: string) {
    this.changeTitleBarSubject.next(value);
  }

  public clearTitleBarValue() {
    this.changeTitleBarSubject.next('');
  }
}
